<div class="container-fluid">
  <h2 class="mb-4 fw-bold text-dark">Future Releases</h2>
  <div class="row g-3">
    <div
      class="col-md-4"
      *ngFor="let feature of features"
    >
      <div class="card border border-secondary shadow-sm h-100">
        <div
          class="card-body d-flex flex-row align-items-center justify-content-start text-center py-2 px-3 pe-none"
        >
          <nr-icon
            [name]="feature?.image"
            sizeClass="icon-size-65 mt-2"
          ></nr-icon>
          <h5 class="card-title fw-semibold mb-0 text-start">{{ feature.name }}</h5>
        </div>
      </div>
    </div>
  </div>
</div>
